export enum FieldDefaultValueKind {
  formula = 'formula' /* значение по умолчанию - формула */,
  data = 'data' /* значение по умолчанию - справочник */,
}
